export default __webpack_public_path__ + "static/media/thankYou.94c3c086.jpg";